import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { createTV } from 'tailwind-variants';
import { TWMConfig } from 'tailwind-variants/dist/config';
import * as twConfig from 'tailwind.config';

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}

export const tv = createTV(twConfig as TWMConfig);
